import {
  EpgItem,
  Episode,
  Movie,
  Season
} from "@/services/apiService/api.types";

export interface OverlayState {
  OverlayOpen: OverlaySection;
  channelEpg: EpgItem[];
  activeEpgItem: EpgItem;
  activeVodItem: Movie | Episode | null;
  activeVodItemDuration: number | null;
  activeVodItemProgressDuration: number | null;
  tvShowMeta: Season[] | null;
}

export const enum OverlayAction {
  UpdateOverlayOpen = "UpdateOverlayOpen",
  UpdateChannelEpg = "updateChannelEpg",
  UpdateActiveVodItemProgressDuration = "UpdateActiveVodItemProgressDuration",
  UpdateEpisodeDuration = "UpdateEpisodeDuration"
}

export const enum OverlayMutation {
  SetOverlayOpen = "SetOverlayOpen",
  ClearOverlayOpen = "ClearOverlayOpen",
  SetChannelEpg = "setChannelEpg",
  SetActiveEpgItem = "SetActiveEpgItem",
  SetActiveVodItem = "SetActiveVodItem",
  SetActiveVodItemDuration = "SetActiveVodItemDuration",
  SetActiveVodItemProgressDuration = "SetActiveVodItemProgressDuration",
  SetTvShowMeta = "SetTvShowMeta"
}

export const enum OverlayGetter {
  GetOverlayOpen = "GetOverlayOpen",
  GetChannelEpg = "GetChannelEpg",
  GetActiveEpgItem = "GetActiveEpgItem",
  GetActiveVodItem = "GetActiveVodItem",
  GetActiveVodItemDuration = "GetActiveVodItemDuration",
  GetActiveVodItemProgressDuration = "GetActiveVodItemProgressDuration",
  GetTvShowMeta = "GetTvShowMeta"
}

export type OverlaySection =
  | "ChannelList"
  | "PlayerControls"
  | "ContentList"
  | "";

export enum TimelineDirection {
  Rewind = "Rewind",
  FastForward = "FastForward"
}

export interface DailyEpg {
  name: string;
  date: string;
}

export interface ChannelEpgParams {
  channelId?: number;
  date?: string;
}

export interface EpisodeDurationData {
  episodeId: number;
  duration: string;
}
